import React from 'react'
import ChatDemo from './Demo'

function Chat() {
    return (
        <ChatDemo isPage={window.location.pathname === "/chat" ? true : false} />
    )
}

export default Chat